import CreateColumn from '../../../../Services/agGrid/createColumn';
import dayjs from 'dayjs';

/**
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // NO 컬럼 (체크박스 포함)
    // - SER_BASIC 화면에서 내려오는 props는 *1(gridRef1/rowData1/RestoreRow1/...) 형태
    // - createColumn.js에서 DeleteNewRow1/RestoreRow1/gridRef1/rowData1 등을 우선으로 매칭함
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),

    CreateColumn(
      'sdCode',
      '재해처벌법코드',
      'center',
      120,
      false,
      false,
      true,
      'text'
    ),

    CreateColumn(
      'evaDate',
      '평가일시',
      'center',
      160,
      false,
      false,
      false,
      'text',
      {
        valueFormatter: (params) => {
          const v = params?.value;
          if (!v) return dayjs().format('YYYY-MM-DD');
          return String(v).substr(0, 10);
        },
        flex: 1,
        minWidth: 160,
      }
    ),

    CreateColumn(
      'evaName',
      '평가자',
      'center',
      140,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 140,
      }
    ),

    CreateColumn(
      'evaPoint',
      '취득점수',
      'right',
      140,
      false,
      false,
      false,
      'number',
      {
        flex: 1,
        minWidth: 140,
      }
    ),
  ];
};

const columnDefs = { getColumnDefs1 };
export default columnDefs;
